import React from 'react';
import { ToolResultField, FieldValue } from './ToolResultField';
import { CheckCircle } from 'lucide-react';

interface ToolResultSingularProps {
  values: FieldValue[];
  tool_name: string;
  action_name: string;
  onLinkClick?: (href: string) => void;
}

const formatActionTitle = (name: string): string => {
  const safeName = (name ?? 'Action').toString();
  return safeName.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
};

/**
 * Renders a single tool execution result as a full-width card
 */
export const ToolResultSingular: React.FC<ToolResultSingularProps> = ({
  values,
  tool_name,
  action_name,
  onLinkClick
}) => {
  if (!values || values.length === 0) {
    return (
      <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
        <p className="text-sm text-gray-600">No data available</p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <CheckCircle className="w-4 h-4 text-green-600" />
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900">{formatActionTitle(action_name)}</h3>
          </div>
        </div>
      </div>

      {/* Fields */}
      <div className="px-4 py-3 divide-y divide-gray-100">
        {values.map((field, index) => (
          <ToolResultField
            key={`${field.path}-${index}`}
            field={field}
            onLinkClick={onLinkClick}
          />
        ))}
      </div>
    </div>
  );
};
